import React from "react";
import {
  HandHeart, Calendar, Shield, Star, BookOpen, Edit3, Languages,
  Users, Sparkles, Flower2, Award,
} from "lucide-react";

/**
 * Small chip showing a community badge (Volunteer, Trustee, Editor, etc.).
 * Maps the icon string from the backend BADGE_CATALOG to a real lucide icon.
 */
const ICONS = {
  "hand-heart": HandHeart,
  "calendar":   Calendar,
  "shield":     Shield,
  "star":       Star,
  "book-open":  BookOpen,
  "edit-3":     Edit3,
  "languages":  Languages,
  "users":      Users,
  "sparkles":   Sparkles,
  "flower":     Flower2,
};

const COLORS = {
  saffron: "bg-saffron/15 text-saffron border-saffron/30",
  blue:    "bg-blue-500/15 text-blue-700 border-blue-500/30",
  navy:    "bg-navy/10 text-navy border-navy/20",
  amber:   "bg-amber-500/15 text-amber-700 border-amber-500/30",
  rose:    "bg-rose-500/15 text-rose-700 border-rose-500/30",
  emerald: "bg-emerald-500/15 text-emerald-700 border-emerald-500/30",
  violet:  "bg-violet-500/15 text-violet-700 border-violet-500/30",
  teal:    "bg-teal-500/15 text-teal-700 border-teal-500/30",
};

export default function BadgeChip({ badge, size = "sm" }) {
  if (!badge) return null;
  const Icon = ICONS[badge.icon] || Award;
  const colorCls = COLORS[badge.color] || COLORS.navy;
  const padding = size === "lg" ? "px-2.5 py-1 text-xs" : "px-1.5 py-0.5 text-[10px]";
  const iconSize = size === "lg" ? 12 : 10;
  return (
    <span
      data-testid={`badge-${badge.type}`}
      title={badge.label}
      className={`inline-flex items-center gap-1 ${padding} ${colorCls} border rounded font-medium uppercase tracking-wider`}
    >
      <Icon size={iconSize} />
      {badge.label}
    </span>
  );
}

export function BadgeRow({ badges, size = "sm", max = null }) {
  if (!badges || badges.length === 0) return null;
  const list = max ? badges.slice(0, max) : badges;
  return (
    <span className="inline-flex flex-wrap gap-1 items-center">
      {list.map((b) => <BadgeChip key={b.badge_id || b.type} badge={b} size={size} />)}
      {max && badges.length > max && (
        <span className="text-[10px] text-navy/45">+{badges.length - max}</span>
      )}
    </span>
  );
}
